<h2 mat-dialog-title>
    <span>Selecionar Conjunto de Conta Contábil</span>
    <button mat-icon-button
            class="close-button"
            (click)="cancelar()"
            matTooltip="Fechar">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content fxLayout="column">
    <p>Múltiplas opções encontradas. Selecione o conjunto de conta contábil desejado:</p>

    <table mat-table [dataSource]="dataSource" class="argumentos-table">
        <!-- Categoria Origem Column -->
        <ng-container matColumnDef="categoriaOrigem">
            <th mat-header-cell *matHeaderCellDef>Conta Contábil Origem</th>
            <td mat-cell *matCellDef="let argumento">{{ argumento.nomeCategoriaOrigem || 'N/A' }}</td>
        </ng-container>

        <!-- Categoria Destino Column -->
        <ng-container matColumnDef="categoriaDestino">
            <th mat-header-cell *matHeaderCellDef>Conta Contábil Destino</th>
            <td mat-cell *matCellDef="let argumento">{{ argumento.nomeCategoriaDestino || 'N/A' }}</td>
        </ng-container>

        <!-- Tipo Importação Column -->
        <ng-container matColumnDef="tipoLancamento">
            <th mat-header-cell *matHeaderCellDef>Tipo Importação</th>
            <td mat-cell *matCellDef="let argumento">{{ argumento.nomeTipoLancamento || '-' }}</td>
        </ng-container>

        <!-- Selecionar Column -->
        <ng-container matColumnDef="selecionar">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let argumento">
                <button mat-icon-button
                        color="primary"
                        (click)="selecionarArgumento(argumento)"
                        [class.selected]="isSelecionado(argumento)"
                        matTooltip="Selecionar esta opção">
                    <mat-icon>check</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
            [class.row-selected]="isSelecionado(row)"></tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" style="margin-top: 10px;">
    <button mat-raised-button (click)="cancelar()">CANCELAR</button>
</mat-dialog-actions>

